import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import purifyMarked from "@ploy-lib/purify-marked";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useTenantImage } from "@ploy-ui/tenants";
import { useIntl, defineMessages } from "react-intl";
import { ImageFit } from "@ploy-ui/core";
import clsx from "clsx";
const useStyles = makeStyles(theme => ({
    root: {
        background: theme.palette.grey[800],
        padding: theme.spacing(2)
    },
    container: {
        paddingTop: 50,
        textAlign: "center",
        [theme.breakpoints.up("sm")]: {
            textAlign: "left"
        }
    },
    flag: {
        padding: theme.spacing(2),
        height: 80
    },
    contactSection: {
        color: theme.palette.grey[500],
        "& h3": {
            marginTop: 0,
            marginBottom: 12
        },
        "& p": {
            fontSize: 11,
            marginTop: 8,
            marginBottom: 0
        },
        "& a": {
            color: theme.palette.grey[500],
            textDecoration: "none",
            "&:hover": {
                color: "#00678a"
            }
        }
    },
    logo: {}
}));
const messages = defineMessages({
    footerInfo: {
        id: "dealer.footer.info",
        defaultMessage: "### Contact information",
        description: "Footer info. Markdown syntax allowed"
    },
    footerContactInfo: {
        id: "dealer.footer.contact_info",
        defaultMessage: `
      ### Contact info
      Email: [demofinans@knowit.no](mailto:demofinans@knowit.no)

      Web: [www.knowit.no](http://www.knowit.no)`,
        description: "Footer contact info. Markdown syntax allowed"
    }
});
export function Footer(props) {
    const intl = useIntl();
    const classes = useStyles(props);
    const footerLogo = useTenantImage("footerLogo");
    return (_jsx("footer", { className: clsx(classes.root, props.className), children: _jsxs(Grid, { container: true, spacing: 2, justifyContent: "center", className: classes.container, children: [_jsx(Grid, { item: true, xs: 12, sm: 3, className: classes.logo, children: _jsx(ImageFit, { src: footerLogo, fit: "contain", className: classes.flag }) }), _jsx(Grid, { item: true, xs: 12, sm: "auto", children: _jsx(Typography, { className: classes.contactSection, dangerouslySetInnerHTML: {
                            __html: purifyMarked(intl.formatMessage(messages.footerInfo))
                        } }) }), _jsx(Grid, { item: true, xs: 12, sm: "auto", children: _jsx(Typography, { className: classes.contactSection, dangerouslySetInnerHTML: {
                            __html: purifyMarked(intl.formatMessage(messages.footerContactInfo))
                        } }) })] }) }));
}
//# sourceMappingURL=Footer.js.map